/**
 * Import all front-end JS scripts.
 * 
 * Compiles to assets/scripts/theme-scripts.js
 */

 /* eslint-disable no-unused-vars */

 // Import vendor files
 import 'what-input'
 import 'slick-carousel'

 // Import ES6 modules (recommended)
 // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
import './base/cookie.js'
import './base/external-links.js';
import './base/menu-level-full.js'
import './base/menu-drawers.js'
import './base/sidebar-menu.js'
import './base/emergency-alerts.js'
import './base/staff-directory.js'
import './base/expanding-table.js' 
import './base/main-navigation';

// Import JS from blocks
import '../../../blocks/accordion/accordion.js'
import '../../../blocks/post-list/post-list.js'


// Or import entire JS files the "old school" way
// import './test.js'